import React from "react";
import InteractiveHeroVisual from './AnimatedSphere';

const HeroSection = () => {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center pt-14">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="display-huge">
                Launching a token without a proper Telegram?
              </h1>
              <p className="body-large">
                TG4Crypto builds your Complete and Professional Telegram Group in{' '}
                <span className="font-bold underline">24 – 48 hours</span>.
              </p>
              <p className="text-base text-gray-400" style={{ letterSpacing: '0.05em' }}>
                Security • Buybot Video + Setup • Welcome System • Custom Commands • 3D spinning logo & More
              </p>
              <div className="pt-2">
                <p className="text-sm text-gray-500 mb-2">Built for projects launching on:</p>
                <p className="text-lg font-bold" style={{ color: 'var(--brand-primary)' }}>
                  Solana • Robinhood Chain • Ethereum • BNB Chain • Sui
                </p>
              </div>
            </div>

            <div className="mb-6">
              <span className="inline-block px-5 py-2.5 rounded-lg text-lg font-bold text-white" style={{ background: 'linear-gradient(135deg, rgba(0, 218, 240, 0.15) 0%, rgba(0, 218, 240, 0.05) 100%)', border: '1px solid rgba(0, 218, 240, 0.4)', letterSpacing: '0.025em' }}>
                All-Inclusive Package: 500 USDC
              </span>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                className="btn-primary dark-button-animate"
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              >
                View Services
              </button>
              <button 
                className="btn-secondary dark-button-animate"
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              >
                Get Started
              </button>
            </div>
          </div>
          
          {/* Right side - Animated Sphere */}
          <div className="flex justify-center lg:justify-end">
            <div 
              className="relative" 
              style={{ 
                width: "700px", 
                height: "700px", 
                overflow: "visible", 
                position: "relative" 
              }}
            >
              <InteractiveHeroVisual />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;